// extracted by mini-css-extract-plugin
export default {"container":"KC8Ir","error":"giAM1"};